var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25508 3.53672L5.99727 0.249609C5.94453 0.196875 5.88594 0.152344 5.82383 0.114844C5.80742 0.105469 5.78984 0.0960938 5.77227 0.0878906C5.76417 0.0833921 5.75538 0.0795844 5.74696 0.0759371L5.74696 0.0759355L5.73945 0.0726563C5.63281 0.0257813 5.5168 0 5.39844 0H1.34375C0.877344 0 0.5 0.377344 0.5 0.84375V11.1562C0.5 11.6227 0.877344 12 1.34375 12H8.65625C9.12266 12 9.5 11.6227 9.5 11.1562V4.13086C9.5 3.9082 9.41211 3.69492 9.25508 3.53672ZM8.18516 3.65547H5.84375V1.29297L8.18516 3.65547ZM1.34375 11.1562H8.65625V4.5H5.84375C5.37734 4.5 5 4.12266 5 3.65625V0.84375H1.34375V11.1562Z",
    fill: "#45464C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1ddb5a25c982bdac38b67cae4a822081.svg";
export { ForwardRef as ReactComponent };